import createGenericContext from '@utils/createGenericContext';
import { CSSProperties, ReactNode } from 'react';

export type ButtonTypeLyft = {
  title: string;
  onClick: () => void;
  color: string;
};

export type AlertContextType = {
  showAlert: (props: AlertProps) => void;
  hideAlert: () => void;
};

export type AlertProps = {
  title: string;
  color?: string;
  isLoader?: boolean;
  message?: string;
  handleConfirm?: () => void;
  buttons?: ButtonTypeLyft[];
  extraMessages?: string[];
  showAlert?: boolean;
  setShowAlert?: (show: any) => void;
  segmentId?: number;
  RenderItem?: () => ReactNode | null;
  messageStyle?: CSSProperties;
  extraMessageStyle?: CSSProperties;
};

export const [AlertContext, AlertContextProvider] =
  createGenericContext<AlertContextType>('AlertContext');
